import * as actions from './actions';
import state from './state';
import mutations from './mutations';

export default {
    namespaced: true,
    actions,
    mutations,
    state,
};
